import title from "./images/title.png";
import Main from "./pages/Main";
import SetQuiz from "./pages/SetQuiz";
import Quiz from "./pages/Quiz";
import Finish from "./pages/Finish";
import handleSubmit from "./handles/handleSubmit";
import "./App.css";
import { useState, useRef } from "react";

function App() {
  const [currentPage, setCurrentPage] = useState("main");
  const [numPreguntes, setNumPreguntes] = useState(10);
  const [data, setData] = useState([]);
  const [score, setScore] = useState(undefined);

  return (
    <div className="App">
      <header className="App-header">
        <img src={title} className="App-logo" alt="logo" />
        <p>
          Quiz per aprendre carrers, direccions i punts d'interes de Barcelona
        </p>
      </header>
      <div className="App-body">
        {currentPage === "main" && <Main changePage={setCurrentPage} />}
        {currentPage === "set-quiz" && (
          <SetQuiz
            changePage={setCurrentPage}
            changePreguntes={setNumPreguntes}
            setData={setData}
          />
        )}
        {currentPage === "quiz" && (
          <Quiz
            changePage={setCurrentPage}
            numPreguntes={numPreguntes}
            setScore={setScore}
            carrers={data[0]}
            carrersIds={data[1]}
          />
        )}
        {currentPage === "finish" && (
          <Finish changePage={setCurrentPage} score={score} />
        )}
      </div>
      <div className="App-footer">Created by Omar-TBR</div>
    </div>
  );
}

export default App;
